module.exports = __webpack_public_path__ + "COBRA - Employee to Cobra Participant Guide.pdf";